import { api } from '@/core/api/';

const baseApiURL = "/api/roles"


//ECG:Roles se mantendran distribuidos. Se debe diseñar hub para acceder a roles de distintas apps
//ECG:filters contiene {name:'nombredefiltro', value:'valordelfiltro'}
export const getRolesSearchResults = (filters) => api.get('/api/roles', {
    params: filters
})

export const getRoleById = (roleId) => api.get(`${baseApiURL}/${roleId}`)
export const getPermissionsInRole = (data) => api.put(`${baseApiURL}/permissionsinrole`, data)
export const saveRole = (payload) => api.post(`${baseApiURL}/saverole`, payload)
    
export const getRolesByApplicattionId = async (applicattionId, filterEspecialst = false) =>  await api.get(`${baseApiURL}/byapplicationid/`, {
    params:{
        applicattionId: applicattionId,
        filterEspecialst: filterEspecialst,
    }
});

export const getRoleTypesList = () => api.get(`${baseApiURL}/roletypes`);
